import { lazy } from 'react';
/** Открывает форму клиента */
export const ClientFormPageAsync = lazy(() => import('./ClientForm/ClientFormPage'));